import { MS_CONFIG_REDIRECT } from "../config";

export const msalConfig = {
  auth: {
    clientId: "ed0d3e14-bcf9-4b79-8805-b2c831e3f115",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: MS_CONFIG_REDIRECT, // Update with your redirect URI
  },
  cache: {
    cacheLocation: "sessionStorage", // or 'localStorage'
  },
};
